import { render, staticRenderFns } from "./StudentChoose.vue?vue&type=template&id=2daa1e0f&scoped=true"
import script from "./StudentChoose.vue?vue&type=script&lang=js"
export * from "./StudentChoose.vue?vue&type=script&lang=js"
import style0 from "./StudentChoose.vue?vue&type=style&index=0&id=2daa1e0f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daa1e0f",
  null
  
)

export default component.exports